export default __webpack_public_path__ + "static/media/wandw.63d602dd.png";